<template>
  <show-page class="flex-lg-row flex-column mb-3">
    <template #default>
      <router-view v-bind="bindProps" @getCourse="getCourse" />
    </template>
    <template #sidebar>
      <course-sidebar
        :loading="loading"
        :topics="topics"
        :course="course"
        class="d-none d-md-flex flex-column"
      />
    </template>
  </show-page>
</template>

<script>
import ShowPage from "@core/components/show-page/ShowPage.vue";
import CourseSidebar from "./Sidebar.vue";
export default {
  components: {
    ShowPage,
    CourseSidebar,
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
    bindProps() {
      return this.$route.path.includes("session")
        ? {
            loadingCourse: this.loading,
            course: this.course,
            sessions: this.sessions || [],
            topics: this.topics,
          }
        : {
            loading: this.loading,
            course: this.course,
            topics: this.topics,
            // sessions:
            //   this.course.sessions && this.course.sessions.sessions
            //     ? this.course.sessions.sessions
            //     : [],
          };
    },
  },
  methods: {
    async getCourse() {
      this.loading = true;
      try {
        let baseUrl = Object.keys(this.userData).length ? "/panel/" : "/front/";
        const { data } = await this.$http.get(
          baseUrl + "courses/" + this.$route.params.id,
          {
            params: {
              includes: ["faqs", "sessions", "events"],
            },
          }
        );
        this.course = data.data;
        this.topics = data.data.topics.map((topic) => {
          topic.sessions = [];
          data.data.sessions.sessions.map((session) => {
            if (session.pivot.topic == topic.key) {
              topic.sessions[session.pivot.sort - 1] = session;
              this.sessions.push(topic.sessions[session.pivot.sort - 1]);
            }
          });
          return topic;
        });
      } catch (err) {}
      this.loading = false;
    },
  },
  data() {
    return {
      loading: false,
      course: {},
      topics: [],
      sessions: [],
    };
  },
  created() {
    this.getCourse();
  },
};
</script>

<style></style>
